import { useParams } from 'react-router-dom'
import { usePermissions } from '~/entities/common/viewer'
import { EditDriver } from '~/features/africa/Drivers/EditDriver'
import { Documents } from '~/features/common/Drivers/Documents'
import { DriverChecks } from '~/features/common/Drivers/DriverChecks'
import { QuickNavigation } from '~/shared/ui/QuickNavigation'
import { QuickNavigationOptions } from '~/shared/ui/QuickNavigation/QuickNavigation'

const quickNavigationOptions: QuickNavigationOptions = [
  { labelI18n: 'checks', anchor: 'checks' },
  { labelI18n: 'basic info', anchor: 'main' },
  { labelI18n: 'passport', anchor: 'passport' },
  { labelI18n: 'foreign Citizens', anchor: 'foreigners' },
  { labelI18n: 'driver license', anchor: 'drivingLicense' },
  { labelI18n: 'additional information', anchor: 'extra' },
  { labelI18n: 'documents', anchor: 'documents' },
]

export function DetailsPageAfrica() {
  const params = useParams<{ driverId: string }>()
  const driverId = params.driverId as string

  const { canDriverChecksView } = usePermissions()

  return (
    <>
      {canDriverChecksView && <DriverChecks driverId={driverId} />}

      <EditDriver />

      <Documents driverId={driverId} />

      <QuickNavigation options={quickNavigationOptions} />
    </>
  )
}
